import { render } from "./InstructionsList.vue?vue&type=template&id=0eba955d&scoped=true"
import script from "./InstructionsList.vue?vue&type=script&lang=js"
export * from "./InstructionsList.vue?vue&type=script&lang=js"

import "./InstructionsList.vue?vue&type=style&index=0&id=0eba955d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eba955d"]])

export default __exports__